import { Checkbox, Input } from '@library/components/inputs';
import type { CheckboxOnChangeArg } from '@library/types/utils';
import { cn } from '@library/component-utils/cn';

export interface ScoringInputsProps {
  isDisabled: boolean;
  isDnp?: boolean;
  isReboot?: boolean;
  score?: number | string | undefined;
  onToggleDnp?: (arg: CheckboxOnChangeArg) => void;
  onToggleReboot?: (arg: CheckboxOnChangeArg) => void;
  onChangeScore?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ScoringInputs = ({
  isDisabled,
  isDnp = false,
  isReboot = false,
  score = undefined,
  onToggleDnp = () => {},
  onToggleReboot = () => {},
  onChangeScore = () => {}
}: ScoringInputsProps) => {
  return (
    <div className="flex justify-between pt-6">
      {/* SCORING ATTRIBUTES */}
      <div className="flex flex-col gap-4">
        <p
          className={cn(
            'text-sm',
            isDisabled ? 'text-soFresh-160' : 'text-soClean-180'
          )}
        >
          Scoring Attributes
          <span className="text-stankonia-100">*</span>
        </p>
        <Checkbox
          id="348924-reboot"
          checked={isReboot}
          onCheckboxChange={onToggleReboot}
          disabled={isDisabled}
          label="Reboot"
        />
        <Checkbox
          id="348924-dnp"
          checked={isDnp}
          onCheckboxChange={onToggleDnp}
          disabled={isDisabled}
          label="DNP"
        />
      </div>

      {/* SCORE  */}
      <div>
        <p
          className={cn(
            'mb-1 text-sm',
            isDisabled ? 'text-soFresh-160' : 'text-soClean-180'
          )}
        >
          Score
          <span className="text-stankonia-100">*</span>
        </p>
        <Input
          className="bg-soFresh-110 text-soClean-100 border-soFresh-140 placeholder:text-soClean-170 block w-80 rounded-md border py-1.5 text-sm leading-6"
          value={score ?? ''}
          onChange={onChangeScore}
          disabled={isDisabled}
        />
      </div>
    </div>
  );
};
